{
  "error": "Błąd",
  "help": "Pomoc",
  "info": "Informacja",
  "success": "Powodzenie",
  "warning": "Ostrzeżenie"
}
